export default __webpack_public_path__ + "static/media/blackringcitadelwing2.521b1e3f.jpg";